import * as React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

type Props = {
    hide: boolean;
    message?: string;
}

function LoadOverlay({ hide, message }: Props) {
    if (hide) return null;

    const overlayStyle: React.CSSProperties = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        flexDirection: 'column',
        gap: '16px'
    };

    const textStyle: React.CSSProperties = {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1A1F4D',
        marginTop: '16px'
    };

    return (
        <div id='overlay' style={overlayStyle}>
            <Spinner size={SpinnerSize.large} />
            <div style={textStyle}>{message || 'Loading...'}</div>
        </div>
    );
}

export default React.memo(LoadOverlay);